import styled from 'styled-components';
import { black, green } from 'utils/style/colors';

export const Container = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const Cell = styled('span')`
  border-radius: 10px;
  width: 2rem;
  height: 2rem;
  text-align: center;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ddd;
  transition: all 0.5s ease;
  margin: 0 1rem;
  :hover {
    color: ${black};
  }
`;

export const Date = styled('span')`
  width: 2rem;
  color: ${green};
`;
